import { IconButton, TableCell, TableRow } from "@mui/material";

function InventoryRow(props) {
  const { assignment, columns, color, handleMoveAssignment } = props;

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          return (
            <TableCell
              component="th"
              scope="row"
              key={`${column.columnName}-${index}`}
            >
              {column.dbName === "sku" ? (
                assignment.product.sku
              ) : column.dbName === "name" ? (
                assignment.product.name
              ) : column.dbName === "stock" ? (
                assignment.stock
              ) : column.dbName === "location" ? (
                assignment.slot.name
              ) : column.dbName === "seller" ? (
                assignment.product.company.social_reason
              ) : column.dbName === "bar_code" ? (
                assignment.product.barcode
              ) : column.dbName === "price" ? (
                assignment.product.price
              ) : column.dbName === "move" ? (
                <IconButton onClick={() => handleMoveAssignment(assignment)}>
                  {" "}
                  <i className="material-icons">add</i>
                </IconButton>
              ) : (
                "COLUMNA DESCONOCIDA"
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

export default InventoryRow;
